import {
  GET_CLUB_REQUEST,
  LIST_CLUBS_REQUEST,
  GET_DYNAMIC_PRICING_CLUB_REQUEST,
  UPDATE_DYNAMIC_PRICING_CLUB_REQUEST
} from './constants';

export const listClubs = () => ({
  type: LIST_CLUBS_REQUEST
});

export const getClub = (slug, onError) => ({
  type: GET_CLUB_REQUEST,
  slug,
  onError
});

export const getDyanamicPricingClub = (shipmentId) => ({
  type: GET_DYNAMIC_PRICING_CLUB_REQUEST,
  shipmentId
});

export const updateDynamicPricingClub = (shipmentId, items) => ({
  type: UPDATE_DYNAMIC_PRICING_CLUB_REQUEST,
  shipmentId,
  items
});
